import { render } from "./SpanishPage.vue?vue&type=template&id=52a28d46&scoped=true"
import script from "./SpanishPage.vue?vue&type=script&lang=js"
export * from "./SpanishPage.vue?vue&type=script&lang=js"

import "./SpanishPage.vue?vue&type=style&index=0&id=52a28d46&scoped=true&lang=css"

import exportComponent from "/Users/johnahnz0rs/00 - JAHN PROJECTS/frequency-lists/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a28d46"]])

export default __exports__